import Analytics from 'analytics'
import segmentPlugin from '@analytics/segment'
import { getLiveConfigurationCache } from './configuration/configurationCache'
import cdpDumpPlugin from './cdpDumpPlugin'
import { shouldPresentBFeature } from './featureCohortTesting'

let segmentAnalytics = null
let plickersAnalytics = null

function initAnalytics() {
  segmentAnalytics = Analytics({
    app: 'plickers-web',
    plugins: [
      segmentPlugin({
        writeKey: process.env.REACT_APP_SEGMENT_KEY,
      }),
    ],
  })
  plickersAnalytics = Analytics({
    app: 'plickers-web',
    plugins: [
      cdpDumpPlugin({
        appName: 'plickers-web',
        writeKey: process.env.REACT_APP_CDPDUMP_WRITE_KEY,
        host: process.env.REACT_APP_CDPDUMP_HOST,
        endpointPrefix: '/cdp/v1',
        // enableDebugLogging: true, // enable this to get more logs into browser console
      }),
    ],
  })
}

export function getAnalyticsProvider() {
  const isAnonymous = !JSON.parse(localStorage.getItem('ls.session'))?.user
  const liveConfig = getLiveConfigurationCache() || {}
  const { analyticsProviderProbability } = liveConfig
  const defaultProbability = process.env.REACT_APP_ANALYTICS_PROVIDER_DEFAULT_PROBABILITY
  const probability = parseInt((analyticsProviderProbability ?? defaultProbability) || '0', 10)
  console.log('ANALYTICS: PROBABILITY', probability, 'default:', defaultProbability, 'analyticsProviderProbability:', analyticsProviderProbability, 'isAnonymous:', isAnonymous)

  // if anonymous, only when the probability is over 50%, use plickers
  if (isAnonymous) {
    return probability >= 50 ? 'plickers' : 'segment'
  }

  return shouldPresentBFeature(probability, 'analyticsProviderUser') ? 'plickers' : 'segment'
}

function getAnalyticsInstance() {
  const analyticsProvider = getAnalyticsProvider()
  console.log('Selected analytics provider:', analyticsProvider)
  if (analyticsProvider === 'segment' && isSegmentInitialized()) {
    return segmentAnalytics
  }
  if (analyticsProvider === 'plickers') {
    return plickersAnalytics
  }
}

function isSegmentInitialized() {
  return !!window.analytics
}

function track(eventName, properties = {}) {
  const analytics = getAnalyticsInstance()
  if (analytics) {
    analytics.track(eventName, properties)
  }
}

function page(pageName, properties = {}) {
  const analytics = getAnalyticsInstance()
  if (analytics) {
    analytics.page({
      name: pageName,
      ...properties,
    })
  }
}

function identify(userId, traits = {}) {
  const analytics = getAnalyticsInstance()
  if (analytics) {
    analytics.identify(userId, traits)
  }
}

function reset() {
  const analytics = getAnalyticsInstance()
  if (analytics) {
    analytics.reset()
  }
}

export default {
  initAnalytics,
  track,
  page,
  identify,
  reset,
}
